module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notfound"
  }, [_c('div', {
    staticClass: "tip"
  }, [_c('h1', [_vm._v("哎呀~您访问的页面已失踪")]), _vm._v(" "), _c('span', [_vm._v("可能原因：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("1.............")]), _vm._v(" "), _c('li', [_vm._v("2.............")]), _vm._v(" "), _c('li', [_vm._v("3.............")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:history.back(-1)"
    }
  }, [_vm._v("返回上一页")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7214bedc","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/Login/error.vue
// module id = 582
// module chunks = 1 2 3 4 5 6 7 8